import { Panel } from '@/components/Panel';
import { useSLA } from '@/hooks/useSLA';
import { Spinner, EmptyState, ProgressBar } from '@00start/ui';

export function SLACompliance() {
  const { metrics, loading } = useSLA();

  return (
    <Panel title="SLA Compliance" mobilePriority={5}>
      {loading ? (
        <div className="flex justify-center py-4"><Spinner size="sm" /></div>
      ) : !metrics || metrics.length === 0 ? (
        <EmptyState title="No SLA data" description="No SLA metrics available." />
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {metrics.map((metric) => (
            <div
              key={metric.metric_name}
              className="bg-slate-800/50 border border-slate-700 rounded-lg p-3 flex flex-col gap-2"
            >
              <div className="text-[11px] font-medium text-slate-200 truncate">
                {metric.metric_name}
              </div>
              <div className="flex items-center gap-2">
                <div className="flex-1">
                  <ProgressBar value={metric.compliance_pct} max={100} />
                </div>
                <span className="text-[11px] text-slate-300 tabular-nums w-10 text-right">
                  {metric.compliance_pct.toFixed(1)}%
                </span>
              </div>
              <div className="flex justify-between text-[10px] text-slate-500">
                <span>Actual: <span className="text-slate-300">{metric.actual_value}</span></span>
                <span>Target: <span className="text-slate-300">{metric.target_value}</span></span>
              </div>
              {metric.violations > 0 && (
                <div className="text-[10px] text-red-400">
                  {metric.violations} violation{metric.violations !== 1 ? 's' : ''}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </Panel>
  );
}
